export default __webpack_public_path__ + "static/media/sienna 1.b0377666.png";